import wAxios from '@/plugins/w/axios/models/axios'
import type { TokenHandshakeHandler } from './types'

export const getDiagnosesHandler: TokenHandshakeHandler = async params => {
	const search = String(params?.search || '').trim()

	const data = await wAxios.post_auth_data('v2/diagnoses', { search })

	return {
		result: {
			data
		}
	}
}
